import { Article } from '@shared-models';

export class ArticleMapper {
  /**
   * Maps an article into the shape the DIAN service expects.
   *
   * `unit` is what ends up as the InvoiceLine `@unitCode` in the XML — the DIAN
   * service forwards `articulo.unit.dian_code` verbatim. The quantity reported
   * alongside it is `ventas.cantidad`, which is expressed in the unit the line
   * was sold in, so reporting the article's base unit would declare a packaging
   * quantity under a base-unit code (12 boxes sent as 12 units).
   *
   * When the line was sold in the article's packaging unit we therefore report
   * that unit instead. Missing packaging data, or a packaging unit with no DIAN
   * code, falls back to the base unit: an invalid or empty code would be
   * rejected by DIAN, and the previous behaviour is the safer default.
   */
  static mapper(article: Article, saleUnitId?: string | null) {
    return {
      codigo: article.codigo,
      descripcion: article.descripcion,
      tax: {
        abbreviation: article.tax[0].abbreviation,
        type: article.tax[0].type,
        value: article.tax[0].value.toString(),
        dian_code: article.tax[0].dian_code,
      },
      type: {
        description: article.type[0].description,
        dian_code: article.type[0].dian_code,
      },
      unit: this.resolveUnit(article, saleUnitId),
    };
  }

  private static resolveUnit(article: Article, saleUnitId?: string | null) {
    const soldInPackagingUnit =
      saleUnitId !== undefined &&
      saleUnitId !== null &&
      article.id_packaging_unit !== undefined &&
      article.id_packaging_unit !== null &&
      Number(saleUnitId) === Number(article.id_packaging_unit);

    const packagingUnit = article.packagingUnit;

    if (soldInPackagingUnit && packagingUnit?.dian_code) {
      return {
        description: packagingUnit.description,
        dian_code: packagingUnit.dian_code,
      };
    }

    return {
      description: article.unit.description,
      dian_code: article.unit.dian_code,
    };
  }
}
